import { Component, OnInit, ViewChild, Injector, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { GetRenewalNonmotorDetailService } from '../../adapters/getRenewalNonmotorDetail.service';
import { environment } from '../../../environments/environment';
import { SharedDataService } from '../../shared/shared-data.service';
import { CheckWrapUpNonMotorService } from 'src/app/adapters/checkWrapUpNonMotor.service';
import { SendLineMessageService } from 'src/app/adapters/sendLineMessage.service';
import { TiscoModalComponent } from 'src/app/shared/component/tisco-modal/tisco-modal.component';
import { BaseComponents } from '../../base.component';
import { default as theme } from '../renewal-theme.json';
import { GetLineTokenService } from 'src/app/adapters/getLineToken.service';
import { CommonModule } from '@angular/common';
import * as uuid from 'uuid';
import liff from '@line/liff';
declare var window: any;
declare var UIkit: any;
declare var $: any;

@Component({
  selector: 'app-nonmotor-detail',
  templateUrl: './nonmotor-detail.component.html',
  styleUrls: ['./nonmotor-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone:false
})
export class NonMotorDetailComponent extends BaseComponents implements OnInit {
  insuredetail_data = signal<any>({});
  dataucid: any;
  comcode: string;
  line_id: any;
  url_default: any;
  liff_id: string;
  rm_channelId: string;
  electronic_channel: string;
  product_type: number
  months: any = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
  
  loader = signal<boolean>(false);
  style: any = {};
  insurance_index: Array<number> = [0]
  userId: string;
  logger_text: string = `nonmotor-detail ${uuid.v4()} =>`
  @ViewChild(TiscoModalComponent) modal;
  // access_token_line: string = ""
  liff_channel_id: string = "";
  channel_line_id: string = "";
  subChannel:number| null = null;
  constructor(
    protected injectorObj: Injector,
    private sharedDataService: SharedDataService,
    private getRenewalNonmotorDetailService: GetRenewalNonmotorDetailService,
    private route: ActivatedRoute,
    private checkWrapUpNonMotorService: CheckWrapUpNonMotorService,
    private sendLineMessageService: SendLineMessageService,
    private router: Router,    
    private getLineTokenService: GetLineTokenService
  ) {
    super(injectorObj);
    this.insuredetail_data.set({
      main_protection : [],
      product_family_flag: null,
      refNo: "",
    })
  }

  async ngOnInit() {
    try {     
      await this.route.queryParams.subscribe(async params => {
        this.dataucid = params['dataucid'];
        this.comcode = params['comcode'];
        this.style = theme[this.comcode];
        this.liff_id = params['appRef'];
        this.rm_channelId = params['rm_channelId'];
        this.electronic_channel = params['electronic_channel'];
        this.product_type = 2;        
        this.liff_channel_id = params['liff_channel_id'];
        this.subChannel = params['subchannel'] ? parseInt(params['subchannel']) : null
        this.logger.info([this.logger_text,'params nonmotor :', params])
        this.sharedDataService.getNonmotorDetail.subscribe(res => {
            this.logger.debug([this.logger_text,'sharedDataService :', res])
            if (res.length == 0) {
              this.getData(this.dataucid);
            } else {
              this.insuredetail_data.set(res);
              this.loader.set(true);
              this.getIndex()
            }
          })
        // await liff.init({ liffId: this.liff_id })
        // if(liff.isLoggedIn() === false && liff.isInClient() === false){
        //   this.logger.info([this.logger_text,'login liff callback path:', window.location.href]);
        //   liff.login({ redirectUri: window.location.href })
        // }else{
        //   this.access_token_line = await liff.getAccessToken();
        //   this.logger.debug([this.logger_text,'access_token_line:', this.access_token_line]);
        //   this.sharedDataService.getNonmotorDetail.subscribe(res => {
        //     this.logger.debug([this.logger_text,'sharedDataService :', res])
        //     if (res.length == 0) {
        //       this.getData(this.dataucid);
        //     } else {
        //       this.insuredetail_data = res;
        //       this.loader = true;
        //       this.getIndex()
        //     }
        //   })           
        // }         
      });
    } catch(error) {
      this.logger.error([this.logger_text,'error:', error.message]);
      if (error.code === '401' || error?.message === "The access token expired" || error?.message === "Load failed" || error?.message === "access_token is required") {
        this.logger.error([this.logger_text,'error line_token nonmotor-detail :', error?.message]);
        liff.logout()
        liff.login({ redirectUri: window.location.href })
        } else {
          this.logger.error(`${this.logger_text} error nonmotor-detail ${error?.message}`);
          this.router.navigate(['/renewal/page-error']);
        }
    }

    if (environment.log_level == 'debug') {
      window.vConsole = new window.VConsole();
    }
  }

  getData(dataucid: any) {
    this.getRenewalNonmotorDetailService.exec({ dataucid: dataucid }).then((res: any) => {
      this.insuredetail_data.set(res.data.obj);
      this.loader.set(true);
      this.getIndex()
      this.logger.debug(this.insuredetail_data());
    }).catch((error)=> {
      this.logger.error(`${this.logger_text} error ${error?.message}`);

      if (error.code === '401' || error?.message === "The access token expired" || error?.message === "Load failed" || error?.message === "access_token is required") {
        this.logger.error([this.logger_text,'error line_token nonmotor-detail getRenewalNonmotorDetailService :', error?.message]);
        liff.logout()
        liff.login({ redirectUri: window.location.href })
        } else {
          this.logger.error(`${this.logger_text} error nonmotor-detail getRenewalNonmotorDetailService ${error?.message}`);
          this.router.navigate(['/renewal/page-error']);
        }
    });
  }

  numberWithCommas(x) {
    if (x == 0) {
      return '-'
    } else {
      const fixedNumber = x.toFixed(2);
      return String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }

  getExpireDate(x) {
    let expiredate = new Date(x);
    let month_expiredate = expiredate.getMonth();
    let month = this.months[month_expiredate];
    let day = expiredate.getDate();
    let year = expiredate.getFullYear() + 543;
    return day + ' ' + month.toString() + ' ' + year.toString();
  }

  getIndex() {
    let index = this.insurance_index
    for (let i = 0; i < this.insuredetail_data().main_protection.length; i++) {
      $(document).ready(function () {
        UIkit.util.on('#object-' + i, 'itemshow', function (e) {
          index[i] = e.detail[0].index;
        });
      });
    }
  }

  getTotalPremium(x) {
    let sum = 0;
    for (let i = 0; i < x.length; i++) {
      sum += x[i].premium;
    }
    const fixedNumber = sum.toFixed(2);
    return String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  onRedirect() {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "dataucid": this.dataucid,
        "comcode": this.comcode,
        "appRef": this.liff_id,
        "rm_channelId": this.rm_channelId,
        "electronic_channel": this.electronic_channel,
        "product_type": this.product_type,
        "liff_channel_id": this.liff_channel_id,
        "channel_line_id": this.channel_line_id,
        "subchannel": this.subChannel
      }
    };
    this.router.navigate(['/renewal/nonmotor-step'], navigationExtras);
  }

  onSubmit() {
    // ตรวจสอบ Wrap Up เเทน Notify400 (WEA03)
    let body = {
      "app_code": this.insuredetail_data().appCode,
      "account_no": this.insuredetail_data().accountNo,
    }
    this.checkWrapUpNonMotorService.exec(body).then((res: any) => {
      if (res.response_code == '40000' && res.response_desc == 'Success') {
        if (res.response_status == true) {
          this.sendLineMessage("Renew-004-NONMOTOR");
        } else {
          this.onRedirect();
        }
      } else {
        this.logger.debug([this.logger_text,"checkWrapUpNonMotorService: ", res])
        this.modal.show({
          title: 'Header Information',
          body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์'
        });
      }
    }).catch((e) => {
      this.logger.error("error checkWrapUpNonMotorService: ", e.message);
      this.modal.show({
        title: 'Header Information',
        body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์'
      });
    });
  }

  sendLineMessage(templateRef) {
    let expire_date = "";
    let company = "";
    const populateLine = {
      // customerId: this.userId,
      liff_channel_id: this.liff_channel_id,
      channel_line_id: this.channel_line_id,
      channelId: this.rm_channelId,
      templateRef: templateRef,
      templateParameter: {
        "company": company,
        "expire_date": expire_date
      },
      message: []
    }
    this.sendLineMessageService.exec(populateLine).then(async (res) => {
      this.logger.debug([this.logger_text,'sendLineMessageService', res])
      if (res['status'] == true) {
        liff.closeWindow();
        this.logger.debug('success')
      }
      else {
        liff.closeWindow();
        this.logger.error('fail')
      }
    }).catch((error) => {
      this.logger.error(this.logger_text,'error sendLineMessageService', error.message)
    });
  }
}
